import styled, { css } from 'styled-components';

import { Text } from '@cashfree-intl/coherent';

const getResultTextStyles = type => {
  if (type === 'scheduled') {
    return css`
      color: #206f84;
      background: #e8f7fd;
    `;
  }

  return css`
    color: #01a934;
    background: #e6fcee;
  `;
};

export const StyledResultText = styled(Text)`
  ${({ type }) => getResultTextStyles(type)}
  padding: 2px 6px;
  border-radius: 2px;
  display: inline-block;
`;
